import { HeaderTitlePage } from '@/components/custom';
import { useUserConnected } from '@/hooks';

const HeaderPage = () => {

	const { userConnected } = useUserConnected();

	if (!userConnected) {
		return <></>
	}

	return (
		<>
			<HeaderTitlePage
				description={
					<p className='text-center'>
						Réglez les vérifications le plus rapidement possible. N'attendez pas qu'il y en ai plusieurs pour commencer.
					</p>
				}
				title={
					<p className='space-x-1 text-center'>
						<span>
							Bienvenue
						</span>
						<span className='text-purple-600'>
							{userConnected.name}
						</span>
					</p>
				} />
		</>
	);

};

export default HeaderPage;
